import {Card, CardContent, Container, Fab, Grid, LinearProgress, TextField, Typography} from "@material-ui/core";

import React, {useContext, useEffect, useRef, useState} from "react";
import {ContainerFiltro, FabContainer} from "./styles";
import {UnidadePageContext} from "../UnidadePageContext";
import {Autocomplete} from "@material-ui/lab";
import useStorage from "@hooks/useStore";
import {Unidade} from "@models/Unidade";
import {GetNomes} from "@services/UnidadeService";
import AddIcon from '@material-ui/icons/Add';
import UnidadeModalSalvarAutoescola from "@pages/UnidadePage/UnidadeModalSalvarAutoescola";


const UnidadeFiltro: React.FC = ({}) => {
    const unidadePageContext = useContext(UnidadePageContext);

    const [unidades, setUnidades] = useStorage<Unidade[]>('url_unidades');
    const [nomeSelecionado, setNomeSelecionado] = useState<any>();
    const search = useRef<any>()
    useEffect(() => {
        if (unidades?.length) return;

        async function init() {
            let nomes = await GetNomes();
            setUnidades(nomes);
        }

        setTimeout(() => {
            init()
        }, 2000);
    }, [])


    const [loading, setLoading] = useState<boolean>(false)

    const buscaPorUnidadeId = async (unidadeId) => {
        setLoading(true);

        await unidadePageContext.buscarPorId(unidadeId);
        setLoading(false);


    }
    const buscarPorAutoescolaId = async (input: HTMLInputElement) => {
        setLoading(true);

        await unidadePageContext.buscarPorAutoescolaId(parseInt(input.value, 0));
        setLoading(false);

        input.value = ""
        setLoading(false)
    }
    return (
      <>
        <Grid item xs={12} md={12} lg={12}>
          <Card>
            <CardContent>
              <Grid container spacing={3}>
                <Grid item md={4} xs={12}>
                  <ContainerFiltro>
                    <TextField
                      type="number"
                      label="Cod unidade"
                      variant="outlined"
                      fullWidth
                      onKeyUp={async (event) => {
                        if (event.key === "Escape") {
                          event.target["value"] = "";
                          return;
                        }
                        if (event.key === "Enter") {
                          if (!event.target["value"]) return;
                          buscaPorUnidadeId(event.target["value"]);
                          event.target["value"] = "";
                        }
                      }}
                      onBlur={(event) => {
                        if (!event.target["value"]) return;
                        buscaPorUnidadeId(event.target["value"]);
                        event.target["value"] = "";
                      }}
                    />
                  </ContainerFiltro>
                </Grid>
                <Grid item md={4} xs={12}>
                  <ContainerFiltro>
                    <TextField
                      type="number"
                      label="Cod autoescola"
                      variant="outlined"
                      fullWidth
                      onKeyUp={(event) => {
                        if (event.key === "Escape") {
                          event.target["value"] = "";
                          return;
                        }
                        if (event.key === "Enter") {
                          if (!event.target["value"]) return;
                          buscarPorAutoescolaId(event.target as any);
                        }
                      }}
                      onBlur={(event) => {
                        if (!event.target["value"]) return;
                        buscarPorAutoescolaId(event.target as any);
                        event.target["value"] = "";
                      }}
                    />
                  </ContainerFiltro>
                </Grid>
                <Grid item md={4} xs={12}>
                  <ContainerFiltro>
                    {unidades?.length && (
                      <Autocomplete
                        fullWidth={true}
                        ref={search}
                        id="combo-box-demo"
                        options={unidades}
                        getOptionLabel={(option) =>
                          `${option.id}  ${option.nome}`
                        }
                        style={{ width: "100%" }}
                        onChange={async (e, a) => {
                          if (!a) return;
                          e.stopPropagation();

                          await buscaPorUnidadeId(a.id);
                          setNomeSelecionado(undefined);
                          if (search?.current) {
                            search.current.value = "";
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            ref={search}
                            {...params}
                            label="Por Nome"
                            variant="outlined"
                          />
                        )}
                      />
                    )}
                  </ContainerFiltro>
                </Grid>
              </Grid>
            </CardContent>
            <Container style={{ marginBottom: "10px" }}>
              {loading && <LinearProgress />}
              <FabContainer>
                <Typography>
                  <Fab
                    className="fab"
                    color="secondary"
                    onClick={() =>
                      unidadePageContext.setModalSalvarAutoescola(true)
                    }
                  >
                    <AddIcon />
                  </Fab>
                </Typography>
              </FabContainer>
            </Container>
          </Card>
        </Grid>

        <UnidadeModalSalvarAutoescola />
      </>
    );
};

export default UnidadeFiltro;
